<template>
  <div>
    <div>
      <b-card>
        <b-tabs pills card>
          <b-tab title="Reporte Venta Diaria Detallado" active>
            <b-row>
              <b-col md="3">
                <br>
                <label for="Fecha">Fecha Inicial</label>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-calendar"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="date" required v-model="fechaIniR"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col md="3">
                <br>
                <label for="Fecha">Fecha Final</label>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-calendar"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="date" required v-model="fechaFinR"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col md="3" v-if="mostrarTR">
                <br>
                <label>Valor Total</label>
                <b-form-input v-model="totalDiario" type="text" placeholder="Total" disabled></b-form-input>
              </b-col>
              <b-col md="1">
                <br>
                <br>
                <b-button variant="success" @click="enviarR">Generar</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" v-if="mostrarTR">
                <br>
                <List
                  :mapState="'restaurantReports'"
                  :showbtn="false"
                  :exportExcel="true"
                  :fields="json_fieldsRVD"
                  nameFileExcel="Reporte restaurante"
                  :allDispatch="'restaurantReportsAux'"
                ></List>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Reporte venta diaria por producto">
            <b-row>
              <b-col md="3">
                <br>
                <label for="Fecha">Fecha Inicial</label>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-calendar"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="date" required v-model="fechaIniReporteProducto"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col md="3">
                <br>
                <label for="Fecha">Fecha Final</label>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-calendar"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="date" required v-model="fechaFinReporteProducto"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col md="3" v-if="mostrarTRPP">
                <br>
                <label>Valor Total</label>
                <b-form-input v-model="totalProducto" type="text" placeholder="Total" disabled></b-form-input>
              </b-col>
              <b-col md="1">
                <br>
                <br>
                <b-button variant="success" @click="consultarReporteProductos">Generar</b-button>
              </b-col>
              <b-col md="1"></b-col>
            </b-row>
            <b-row>
              <b-col md="12" v-if="mostrarTRPP">
                <br>
                <List
                  :mapState="'restaurantReports'"
                  :exportExcel="true"
                  :excelHead="json_fieldsRPP"
                  nameFileExcel="reporteVentaDiariaPorProducto.xls"
                  :showbtn="false"
                  :allDispatch="'restaurantReportsAux'"
                ></List>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Reporte de Movimientos">
            <b-row>
              <b-col md="3">
                <br>
                <label for="Fecha">Fecha Inicial</label>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-calendar"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="date" required v-model="fechaInicialUsuario"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col md="3">
                <br>
                <label for="Fecha">Fecha Final</label>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-calendar"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="date" required v-model="fechaFinalUsuario"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col md="3">
                <br>
                <label for="nombre">Usuario</label>
                <b-form-input
                  v-model="idUser"
                  type="text"
                  placeholder="Buscar Usuario"
                  text="Buscar"
                  @change="consultar"
                ></b-form-input>
              </b-col>
              <b-col md="3">
                <br>
                <label for="Saldo">Saldo Actual</label>
                <b-form-input v-model="saldoUsuario" type="text" placeholder="Saldo" disabled></b-form-input>
              </b-col>
              <b-col md="9">
                <br>
                <label for="Numbreu">Nombre usuario</label>
                <b-form-input
                  v-model="nombreUsuario"
                  type="text"
                  placeholder="Nombre Usuario"
                  disabled
                ></b-form-input>
              </b-col>
              <b-col md="1">
                <br>
                <br>
                <b-button variant="success" @click="ObtenerReportesPorPersona">Generar</b-button>
              </b-col>
              <b-col md="1"></b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <br>
                <List
                  :mapState="'restaurantReports'"
                  :showbtn="false"
                  v-if="mostrarReportePorPersona"
                  :allDispatch="'restaurantReportsAux'"
                ></List>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import List from "@/components/modules/base/list.vue";
import { currencyFormat } from "@/api";
Vue.component("downloadExcel", JsonExcel);
export default {
  name: "Lists",
  data() {
    return {
      fechaIniR: "",
      fechaFinR: "",
      fechaIniReporteProducto: "",
      fechaFinReporteProducto: "",
      fechaInicialUsuario: "",
      fechaFinalUsuario: "",
      idUser: "",
      mostrarTR: false,
      mostrarTRPP: false,
      mostrarReportePorPersona: false,
      idReportePersonal: null,
      nombreUsuario: "",
      saldoUsuario: "",
      List2: "",
      totalDiario: "",
      totalProducto: "",
      json_fieldsRVD: {
        "Id Usuario": "id",
        Nombres: "name",
        Documento: "num_doc",
        "fecha y hora": "datetime",
        Descripcion: "products",
        Valor: "total"
      },
      json_data: "",
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ]
    };
  },
  components: {
    List
  },
  methods: {
    enviarR() {
      this.mostrarTR = false;
      let array = {
        fechaIniR: this.fechaIniR + " 00:00:00",
        fechafinR: this.fechaFinR + " 23:59:00"
      };
      let mostrarTR = "";
      this.$store.dispatch("restaurantReportsAll", array).then(response => {
        if (this.$store.getters.restaurantReports.name != "") {
          this.List = this.$store.getters.restaurantReports;
          this.json_data = this.$store.getters.restaurantReports.items;
          let mitotal = 0;
          this.json_data.forEach(element => {
            let varsum = element.valor.replace(",", "");
            mitotal += Number(varsum);
          });
          this.totalDiario = currencyFormat(mitotal);
          this.mostrarTR = true;
        } else {
          this.mostrarTR = false;
        }
      });
    },
    consultar() {
      let array = { id: this.idUser };
      this.$store.dispatch("cafeteriaReportsDataUser", array).then(response => {
        if (this.$store.getters.cafeteriaReports != null) {
          this.idReportePersonal = this.$store.getters.cafeteriaReports.id;
          this.nombreUsuario = this.$store.getters.cafeteriaReports.name;
          this.saldoUsuario = this.$store.getters.cafeteriaReports.saldo;
          console.log("nombre", this.$store.getters.cafeteriaReports);
        } else {
          alert("No Existe Usuario");
        }
      });
    },
    consultarReporteProductos() {
      this.mostrarTRPP = false;
      let array = {
        fechaInicioReporte: this.fechaIniReporteProducto + " 00:00:00",
        fechaFinReporte: this.fechaFinReporteProducto + " 23:59:00"
      };
      this.$store
        .dispatch("restaurantReportsProducts", array)
        .then(response => {
          if (this.$store.getters.restaurantReports.items) {
            console.log("entro", this.$store.getters.restaurantReports);
            this.List = this.$store.getters.restaurantReports;
            this.json_fieldsRPP = this.$store.getters.restaurantReports.items;
            let mitotal = 0; 
            this.json_fieldsRPP.forEach(element => {
              let varsum = element.sumatoria.replace(",", "");
              mitotal += Number(varsum);
            });
            this.totalProducto = currencyFormat(mitotal);
            setTimeout(() => {
              this.mostrarTRPP = true;
            }, 100);
            //this.mostrarTRPP = true;
          } else {
            this.mostrarTRPP = true;
          }
        });
    },
    ObtenerReportesPorPersona() {
      if (!this.idReportePersonal) {
        alert("Usuario para busqueda es requerido");
        return;
      }
      this.mostrarReportePorPersona = false;
      let array = {
        idUsuario: this.idReportePersonal,
        fechaInicialUsuario: this.fechaInicialUsuario + " 000:00:00",
        fechaFinalUsuario: this.fechaFinalUsuario + " 23:59:00"
      };
      let mostrarReportePorPersona = "";
      this.$store.dispatch("restaurantReportsUsuario", array).then(Response => {
        if (this.$store.getters.controlaccesoreports.name != "") {
          this.json_data = this.$store.getters.cafeteriaReports.items;
          this.mostrarReportePorPersona = true;
        } else {
          this.mostrarReportePorPersona = false;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/restaurant/reports/list.vue